module.exports = __webpack_public_path__ + "static/media/imagem21.babf7eb8.jpeg";